/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import Page from '../../../../Page';
import { LoadingButton } from '@material-ui/lab';
import {
    Card,
    Grid,
    TextField,
    Container,
    Tooltip,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Stack,
    ButtonGroup
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from '../../../Common/AlertDialog';
import MenuItem from '@material-ui/core/MenuItem';
import { PhoneNumberUtil } from 'google-libphonenumber';

var screenCode = "FARMER"

export function ContactPerson({ handleNext, handleBack, farmerId }) {
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [farmerContactPersonID, setFarmerContactPersonID] = useState();
    const [contactArray, setContactArray] = useState([]);
    const [groupFactory, setGroupFactory] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const phoneNumberUtil = PhoneNumberUtil.getInstance();
    const [allDisableButton, setAllDisableButton] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        submitButtonName: "Add",
        pageheadername: "Add Contact Person details"
    });

    const [title, setTitle] = useState();
    const [formData, setFormData] = useState({
        title: 0,
        otherTitle: '',
        name: '',
        pname: '',
        designation: '',
        primaryContactNumber: '',
        secondnumber: '',
        email: '',
    });

    useEffect(() => {
        trackPromise(GetFarmerContactPersonByFarmerID());
        GetModeofOperationbyFarmerID(farmerId);
    }, []);

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setGroupFactory({
            ...groupFactory,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function GetModeofOperationbyFarmerID(farmerId) {
        const res = await services.GetModeofOperationbyFarmerID(farmerId)
        if (res == 2) {
            setAllDisableButton(true)
        }
        else {
            setAllDisableButton(false)
        }
    }

    const contactPersonSaveSchema = Yup.object().shape({
        title: Yup.number().min(1, 'Point of Contact - Title is Required').required('Point of Contact - Title is Required'),
        //name: Yup.string().required('Point of Contact - Full Name required').matches(/^[aA-zZ\s\.]+$/, "Only alphabets are allowed for this field"),
        name: Yup.string().required('Point of Contact - Full Name required').matches(/^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/, "Only alphabets are allowed for this field"),
        pname: Yup.string().required('Point of Contact - Preferred Name required').matches(/^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/, "Only alphabets are allowed for this field"),
        designation: Yup.string().required('Point of Contact - Designation required').matches(/^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/, "Only alphabets are allowed for this field"),
        primaryContactNumber: Yup.string().test('phone-number', 'Invalid phone number', (value) => validatePhoneNumber(value)),
        //primaryContactNumber: Yup.string().required('Primary Point of Contact - Contact Number/sis required').matches(/^\d{10}$/,'phone-number', 'Invalid phone number', (value) => {return validatePhoneNumber(value);}),
        secondnumber: Yup.string().nullable().matches(/^\d{10}$/, 'phone-number', 'Not a valid Secondary Number', (value) => { return validatePhoneNumber(value); }),
        email: Yup.string().nullable().matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, 'Not a valid E-Mail Address'),
        otherTitle: Yup.string().when('title', {
            is: (title) => title === 5,
            then: Yup.string().required('Other Title is Required').matches(/^[aA-zZ\s\.]+$/, 'Empty space & space before text are not allowed'),
            otherwise: Yup.string().nullable(),
        }),
    });

    const formik = useFormik({
        initialValues: {
            title: formData.title,
            otherTitle: formData.otherTitle,
            name: formData.name,
            pname: formData.pname,
            designation: formData.designation,
            primaryContactNumber: formData.primaryContactNumber,
            secondnumber: formData.secondnumber,
            email: formData.email,
        },

        validationSchema: contactPersonSaveSchema,
        onSubmit: (values) => {
            addGrid(values);
        },
        enableReinitialize: true
    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        setTitle(formik.values.title);
    }, [formik.values.title]);

    useEffect(() => {
        if (formik.values.title != 5) {
            setValues({
                ...values,
                otherTitle: ""
            })
        }
    }, [formik.values.title]);

    // useEffect(() => {
    //     setValues({
    //     ...values,
    //     otherTitle:" "
    //     })
    // }, [formik.values.title]);

    async function addGrid(values) {
        const exists = contactArray.find(x => x.fullName === values.name);
        if (exists) {
            toast.error("Name already Exists.");
        }
        else {
            if (pageProps.Edit != true) {
                let contactPerson = {
                    farmerContactPersonID: parseInt(0),
                    title: parseInt(values.title),
                    farmerID: parseInt(farmerId),
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    fullName: values.name,
                    preferredName: values.pname,
                    designation: values.designation,
                    primaryContactNumber: values.primaryContactNumber,
                    secondnumber: values.secondnumber,
                    email: values.email,
                    otherTitle: values.otherTitle
                };
                const res = await services.SaveFarmerContactPersonDetail(contactPerson);
                if (res.statusCode == 'Success') {
                    toast.success("Contact Person Saved Succesfully");
                    trackPromise(GetFarmerContactPersonByFarmerID(farmerId));
                    clearAll();
                } else {
                    toast.error("Error occured in Farmer Contact Person Details.");
                }
            }
            else {
                let updateContactPerson = {
                    farmerContactPersonID: parseInt(pageProps.editingID),
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    title: parseInt(values.title),
                    fullName: values.name,
                    preferredName: values.pname,
                    designation: values.designation,
                    primaryContactNumber: values.primaryContactNumber,
                    secondnumber: values.secondnumber,
                    email: values.email,
                    otherTitle: values.otherTitle

                };
                const res = await services.UpdateFarmerContactPersonDetail(updateContactPerson);
                if (res.statusCode == 'Success') {
                    toast.success("Contact Person Details Updated Succesfully");
                    trackPromise(GetFarmerContactPersonByFarmerID(farmerId));
                    setPageProps({
                        ...pageProps,
                        editingID: 0,
                        Edit: false,
                        submitButtonName: "Add",
                    })
                    clearAll();
                } else {
                    toast.error("Error occured in Contact Person Details.");
                }
            }
        }
    }

    function validatePhoneNumber(phoneNumber) {
        try {
            const number = phoneNumberUtil.parseAndKeepRawInput(phoneNumber, 'LK');
            return phoneNumberUtil.isValidNumber(number);
        } catch (error) {
            return false;
        }
    };

    async function GetFarmerContactPersonByFarmerID() {
        var res = await services.GetFarmerContactPersonByFarmerID(farmerId);
        if (res.statusCode === "Success") {
            setContactArray(res.data);
        }
    }

    async function DeleteItem(index) {
        if (contactArray[index].farmerContactPersonID !== undefined) {
            const res = await services.DeleteFarmerContactDetails(contactArray[index].farmerContactPersonID);
            var result = contactArray.filter((img, i) => i !== index);

            setContactArray(result);

            if (res.data === 1) {
                toast.success('Contact Person Deleted Successfully');
            } else {
                toast.error('Error Occured In Contact Person Delete');
            }

        } else {
            var result = contactArray.filter((x, i) => i !== index);
            setContactArray(result);
            toast.success('Contact Person Deleted Successfully');
        }
    }

    async function clearAll() {
        formik.resetForm();
    }

    function confirmData(y) {
        if (y) {
            DeleteItem(farmerContactPersonID);
        }
    }

    function handleConfirm(data) {
        setFarmerContactPersonID(data);
        setEnableConfirmMessage(true);
    }

    function handleEdit(rowData, index) {
        var array = [...contactArray];
        setValues({
            ...values,
            title: rowData.title,
            otherTitle: rowData.otherTitle,
            name: rowData.fullName,
            pname: rowData.preferredName,
            designation: rowData.designation,
            primaryContactNumber: rowData.primaryContactNumber,
            secondnumber: rowData.secondnumber,
            email: rowData.email
        })
        array.splice(index, 1);
        setPageProps({
            ...pageProps,
            editingID: rowData.farmerContactPersonID,
            Edit: true,
            submitButtonName: "Update",
        })
        setContactArray(array);

    }

    return (
        <>
            <LoadingComponent />
            <Page title="Contact Details  |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">{(factoryType == 1 || factoryType == 3) ? "View Contact Person Details" : "Contact Person Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Income & Assets">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Supplier Produce">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleNext}
                                                    >
                                                        <ArrowForwardIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField select
                                            fullWidth
                                            size="small"
                                            label="Point of Contact - Title *"
                                            value={formik.values.title}
                                            onChange={(event) => {
                                                formik.handleChange(event);
                                                // Check if the selected value is 'Other' to enable/disable the other text field
                                                if (event.target.value === 5) {
                                                    formik.setFieldValue('otherTitle', '');
                                                }
                                            }}
                                            {...getFieldProps('title')}
                                            error={Boolean(touched.title && errors.title)}
                                            helperText={touched.title && errors.title}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        >
                                            <MenuItem key={0} value={0}>Select Title</MenuItem>
                                            <MenuItem value={1}> Mr.</MenuItem>
                                            <MenuItem value={2}> Mrs.</MenuItem>
                                            <MenuItem value={3}> Ms.</MenuItem>
                                            <MenuItem value={4}> Prefer not to mention</MenuItem>
                                            <MenuItem value={5}> Other</MenuItem>
                                        </TextField>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Other Title *"
                                            value={formik.values.otherTitle}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('otherTitle')}
                                            error={Boolean(touched.otherTitle && errors.otherTitle)}
                                            helperText={touched.otherTitle && errors.otherTitle}
                                            disabled={factoryType == 1 || factoryType == 3 || formik.values.title != 5 || allDisableButton}
                                        />
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Point of Contact - Full Name *"
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('name')}
                                            error={Boolean(touched.name && errors.name)}
                                            helperText={touched.name && errors.name}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        />
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Point of Contact - Preferred Name *"
                                            value={formik.values.pname}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('pname')}
                                            error={Boolean(touched.pname && errors.pname)}
                                            helperText={touched.pname && errors.pname}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        />
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Point of Contact - Designation *"
                                            value={formik.values.designation}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('designation')}
                                            error={Boolean(touched.designation && errors.designation)}
                                            helperText={touched.designation && errors.designation}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        />
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Point of Contact - Primary Contact Number/s *"
                                            value={formik.values.primaryContactNumber}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('primaryContactNumber')}
                                            error={Boolean(touched.primaryContactNumber && errors.primaryContactNumber)}
                                            helperText={touched.primaryContactNumber && errors.primaryContactNumber}
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        />
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <Stack width={340}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Point of Contact - Secondary Contact Number/s "
                                                value={formik.values.secondnumber}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('secondnumber')}
                                                error={Boolean(touched.secondnumber && errors.secondnumber)}
                                                helperText={touched.secondnumber && errors.secondnumber}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            />
                                        </Stack>
                                        <Stack width={340}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Point of Contact - Email Address"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('email')}
                                                error={Boolean(touched.email && errors.email)}
                                                helperText={touched.email && errors.email}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            />
                                        </Stack>
                                    </Stack>
                                    <Divider />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                            disabled={pageProps.Edit || factoryType == 1 || factoryType == 3 || allDisableButton}
                                        >
                                            Clear
                                        </LoadingButton>
                                        <LoadingButton
                                            size="medium"
                                            type="submit"
                                            variant="outlined"
                                            color='secondary'
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        >
                                            {pageProps.submitButtonName}
                                        </LoadingButton>
                                    </Stack>
                                    <Card>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            {(contactArray.length > 0) ?
                                                <Grid item xs={12}>
                                                    <TableContainer >
                                                        <Table style={{ minWidth: 850 }} aria-label="caption table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center">Point of Contact - Title</TableCell>
                                                                    <TableCell align="center">Point of Contact - Preferred Name</TableCell>
                                                                    <TableCell align="center">Point of Contact - Designation</TableCell>
                                                                    <TableCell align="center">Point of Contact - Contact Number/s</TableCell>
                                                                    {(factoryType == 1 || factoryType == 3) ? null :
                                                                        <TableCell align="center">Action</TableCell>}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {contactArray.map((rowData, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.title == 1
                                                                                ? 'Mr.'
                                                                                : rowData.title == 2
                                                                                    ? 'Mrs.'
                                                                                    : rowData.title == 3
                                                                                        ? 'Ms.'
                                                                                        : rowData.title == 4
                                                                                            ? 'Prefer not to mention'
                                                                                            : rowData.title == 5
                                                                                                ? rowData.otherTitle : ""}
                                                                        </TableCell>
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.preferredName}
                                                                        </TableCell>
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.designation}
                                                                        </TableCell>
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {rowData.primaryContactNumber}
                                                                        </TableCell>
                                                                        {(factoryType == 1 || factoryType == 3) ? null :
                                                                            <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                                {pageProps.Edit != true ?
                                                                                    <Tooltip title="Edit">
                                                                                        <IconButton
                                                                                            variant="outlined"
                                                                                            onClick={() => handleEdit(rowData, index)}>
                                                                                            <EditIcon />
                                                                                        </IconButton>
                                                                                    </Tooltip> : null}
                                                                                <Tooltip title="Delete">
                                                                                    <IconButton
                                                                                        variant="outlined"
                                                                                        color="error"
                                                                                        onClick={() => handleConfirm(index)}>
                                                                                        <DeleteIcon />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </TableCell>}
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                                : null}
                                        </Stack>
                                    </Card>

                                </Stack>
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to delete Contact Person details ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page >
        </>
    )
}